import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Form } from './FormLogin';
import { fetchLogin } from '@app/src/views/Login/login/state/login/actions';
import * as selectUser from '@app/src/views/Login/login/state/login/selectors';

const FormContainer = reduxForm({
  form: 'loginForm',
  onSubmit (fields, dispatch, { history, url }) {
    dispatch(fetchLogin(fields, history, url));
  }
})(Form);

const mapStateToProps = state => ({
  errorMessage: selectUser.getErrorMessage(state),
  isFetching: selectUser.getIsFetching(state)
});

const FormLoginContainer = connect(
  mapStateToProps
)(FormContainer)

export default FormLoginContainer;
